import { render, staticRenderFns } from "./LinkActions.vue?vue&type=template&id=dbfc8d62"
import script from "./LinkActions.vue?vue&type=script&lang=js"
export * from "./LinkActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports